<script setup lang="ts">
  /**
   * Counter — 03-components/07a-counter · OSCloud DS 1.1.27
   */
  import { computed } from 'vue'

  import type { BfCounterTone } from './BfCounterTypes'

  const props = withDefaults(defineProps<{ tone?: BfCounterTone }>(), { tone: 'neutral' })

  const toneClass = computed(() => (props.tone === 'neutral' ? '' : `counter--${props.tone}`))
</script>

<template>
  <span class="counter" :class="toneClass">
    <slot />
  </span>
</template>

<style scoped lang="scss">
  .counter {
    --counter-surface: var(--bf-grey-light);
    --counter-text: var(--bf-dusky-1); /* not --bf-dusky-2: 4.5:1 on --bf-grey-light needs the darker step */
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 18px;
    padding: 1px 6px; /* the card's declared exception to --bf-sp-* */
    border-radius: var(--bf-r-sm);
    background: var(--counter-surface);
    color: var(--counter-text);
    font-family: var(--bf-font-display);
    font-size: var(--bf-fs-micro);
    font-weight: var(--bf-fw-semibold);
    line-height: var(--bf-lh-snug);
    letter-spacing: var(--bf-tr-counter);
    font-variant-numeric: tabular-nums;

    &--accent {
      --counter-surface: var(--bf-orange-ultralight);
      --counter-text: var(--bf-orange-dark);
    }

    &--success {
      --counter-surface: var(--bf-green-light);
      --counter-text: var(--bf-green);
    }

    &--error {
      --counter-surface: var(--bf-error-bg);
      --counter-text: var(--bf-error-accent);
    }

    &--information {
      --counter-surface: var(--bf-info-bg);
      --counter-text: var(--bf-info-accent);
    }
  }
</style>
